import React from "react";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";

import AvatarsImage from "../../../assets/images/png/home/avatars.webp";

import SchoolImage from "../../../assets/images/png/school/all-school.webp";

import * as Animate from "react-reveal";

const SchoolHeader = ({
  selectedSchoolData,
  avatarText,
  hasButtonLink = false,
  buttonLinkTitle,
  buttonLinkUrl,
}) => {
  return (
    <header className="pb-16 school-header-section">
      <HeaderNavigation />
      <div className="pt-2 md:pt-16 container px-4 mx-auto">
        <div className="flex flex-wrap flex-row">
          <div className="w-full lg:w-6/12 mb-8">
            <Animate.Fade bottom>
              <h2 className="text-secondary font-mono text-2xl md:text-3xl lg:text-3xl font-semibold leading-snug mt-6">
                Welcome to Utiva
              </h2>
              <h2 className="mt-4 text-primary font-mono text-5xl md:text-6xl lg:text-7xl font-semibold ">
                {selectedSchoolData?.name}
              </h2>
              <p className="text-default pt-8 w-full lg:w-11/12 xl:w-10/12 text-base lg:text-lg lg:leading-8">
                {selectedSchoolData.description}
              </p>

              {hasButtonLink && (
                <div className="pt-12 flex">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={buttonLinkUrl || "/"}
                    className="custom-btn custom-btn-with-shadow  text-white bg-secondary pl-6 lg:pl-8 py-4 text-center rounded-lg text-sm md:text-base  inline-flex items-center font-medium focus:outline-none mb-4"
                  >
                    {buttonLinkTitle}
                    <span className="pl-4 pr-4 lg:pr-6">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5625 7.30121C12.8699 6.99382 12.8699 6.49544 12.5625 6.18805L7.5533 1.17884C7.24591 0.871448 6.74753 0.871448 6.44014 1.17884C6.13275 1.48623 6.13275 1.98461 6.44014 2.292L10.8928 6.74463L6.44014 11.1973C6.13275 11.5047 6.13275 12.003 6.44014 12.3104C6.74753 12.6178 7.24591 12.6178 7.5533 12.3104L12.5625 7.30121ZM0.902344 7.53175H12.0059V5.95751H0.902344V7.53175Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
              )}

              <div className="pt-12">
                <Animate.Fade bottom>
                  <div className="flex flex-row items-center">
                    <img
                      src={AvatarsImage}
                      className="w-16 lg:w-20"
                      alt="People"
                    />

                    <p className="pl-4 font-mono text-xs lg:text-sm text-gray">
                      {avatarText || "Subsidised Fee From PayFi"}
                    </p>
                  </div>
                </Animate.Fade>
              </div>
            </Animate.Fade>
          </div>
          <div className="w-full lg:w-6/12 relative rounded-md lg:pl-12">
            <div className="relative block">
              <img
                src={selectedSchoolData?.image || SchoolImage}
                width="100%"
                height="100%"
                alt=""
                className=""
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default SchoolHeader;
